"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../../../constants");
var ManagerStatus = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var status = _ref.status,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  if (!status) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledManagerStatus, {
    className: className,
    status: status
  });
});
ManagerStatus.displayName = 'ManagerStatus';
var StyledManagerStatus = _styledComponents["default"].div.withConfig({
  displayName: "ManagerStatus__StyledManagerStatus",
  componentId: "sc-1sfqwij-0"
})(["border-radius:50%;height:10px;width:10px;", " ", " ", " ", ""], function (_ref2) {
  var status = _ref2.status;
  return status === _constants.MANAGER_STATUSES.ONLINE && "\n    background-image: linear-gradient(to top, #f7aa1b, #faed61);\n  ";
}, function (_ref3) {
  var status = _ref3.status;
  return (status === _constants.MANAGER_STATUSES.IN_SERVICE || status === _constants.MANAGER_STATUSES.READY) && "\n    background-image: linear-gradient(to top, #00b0b6, #00e04b);\n  ";
}, function (_ref4) {
  var status = _ref4.status;
  return status === _constants.MANAGER_STATUSES.DND && "\n    background-image: linear-gradient(to top, #e5200e, #ff860c);\n  ";
}, function (_ref5) {
  var status = _ref5.status;
  return (status === _constants.MANAGER_STATUSES.AFTER_SERVICE || status === _constants.MANAGER_STATUSES.OFFLINE) && "\n    background-color: #c2c5cc;\n  ";
});
var _default = exports["default"] = ManagerStatus;